import ajax from "@/utils/ajax.js";
import tokenService from "@/services/tokenService.js";
import store from '@/store/index.js';

export default {
    async loginFromWeChatAsync(input) {
        let response = await ajax.post("/member/LoginFromWeChatAsync", input);
        return JSON.parse(response.result);
    },
    async refreshTokenAsync() {
        let response = await ajax.get("/member/RefreshTokenAsync");
        return JSON.parse(response.result);
    },
    async getMemberInfoAsync() {
        let response = await ajax.get('/member/GetMemberForWeChatAsync');
        return response.result;
    },
    async getLoginUrl(redirectUrl) {
        let r = await ajax.get(`/member/GetLoginUrl?redirectUrl=${redirectUrl}`);
        return r.result;
    },
    async registMemberCardAsync(input) {
        return await ajax.post("/member/RegistMemberCardAsync", input);
    },
    async getElectronicMemberCardAsync() {
        let response = await ajax.get('/member/GetElectronicMemberCardAsync');
        return response.result;
    },
    async renewMemberCardAsync(id) {
        return await ajax.post("/member/RenewMemberCardAsync", {
            id: id
        });
    },
    async bindStaffAsync(input) {
        return await ajax.post("/member/BindStaffAsync", input);
    },
    async customerLogoutAsync() {
        const token = await this.refreshTokenAsync();
        tokenService.setToken(token.access_token);
        await store.dispatch('memberModule/refreshMemberAsync');
    }
}